import { useContext, useEffect, useState } from "react";
import Page from "src/components/Report/Page";
import jobContext from "src/context/jobContext";
import { getJalaliSeasonYear } from "src/utils/getJalaliSeasonYear";

export default function Page2t() {
    const { job } = useContext(jobContext)
    const [data, setData] = useState({})
    useEffect(() => {
        if (job.data) {
            setData(JSON.parse(job.data))
        }
    }, [job])


    return (
        <Page isInnerPage={false}>
            <div className="flex flex-col gap-4 h-full items-center justify-center">
                <div className="flex justify-center items-center">
                    <img src="assets/img/allah.png" className="w-[400px]" />
                </div>
                <div className="border border-solid border-gray-800 flex flex-col gap-3 w-[500px] pt-2">
                    <div className="flex gap-2 px-4">
                        <span className="font-bold">نام سازمان:</span>
                        <span>{job?.organization?.name}</span>
                    </div>
                    <div className="flex gap-2 px-4">
                        <span className="font-bold">عنوان گزارش:</span>
                        <span>تدوین شناسنامه مشاغل</span>
                    </div>
                    <div className="flex gap-2 px-4">
                        <span className="font-bold">طراح گزارش:</span>
                        <span>جابونت</span>
                    </div>
                    <div className="flex gap-2 px-4">
                        <span className="font-bold">زمان اجرا:</span>
                        <span>{getJalaliSeasonYear()}</span>
                    </div>
                    <div className="bg-black text-white justify-center p-1 flex ">
                        مشخصات پایه‌ای شغل
                    </div>
                </div>
                <div className="justify-center p-1 flex flex-col gap-1 w-[500px]">
                    <div className="flex gap-2 px-8 border-b-2 border-solid border-black w-full">
                        <span className="font-bold">عنوان شغل :</span>
                        <span>{(job.title)}</span>
                    </div>
                    <div className="flex gap-2 px-8 border-b-2 border-solid border-black w-full">
                        <span className="font-bold">شناسه:</span>
                        <span>{parseInt(job.id) + 1000}</span>
                    </div>
                    <div className="flex gap-2 px-8 border-b-2 border-solid border-black w-full">
                        <span className="font-bold">واحد سامانی:</span>
                        <span>{job.orgUnit}</span>
                    </div>
                    <div className="flex gap-2 px-8 border-b-2 border-solid border-black w-full">
                        <span className="font-bold">رده شغلی:</span>
                        <span>{data?.rade ? Object?.entries(data?.rade)?.find(([key, value]) => value === true)?.[0] : ""}</span>
                    </div>
                    <div className="bg-gray-50 mt-8 rounded-xl p-5">
                        <div className="flex gap-2 px-8 w-full justify-center">
                            <span className="font-bold mb-4">تعریف شغل:</span>
                        </div>
                        <div className="px-2 text-justify">
                            {data?.jobDefinition}
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    )
}